module.exports = __webpack_public_path__ + "img/icon59.285d71b7.png";